const SendContactEmail_mutate = `
mutation SendContactEmail($name: String!, $email: String!, $message: String!, $phone: String){
  sendContactEmail(name: $name, email: $email, message: $message, phone: $phone){
    success
  }
}`;

module.exports = {
  CONTACT_EMAIL_MUTATION: SendContactEmail_mutate,
};
